import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Credentials',
  attributeName: 'sourceFilesFormGroup',
  
  fields: [
    
    {
      attributeName: 'endpoint',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'IP for SFTP / Bucket name, Url or Endpoint for S3 and GCS',
      label: 'Endpoint',
      helpText: 'IP or Endpoint for this Origin',
      errorText: '',
    },             
    {
      label: 'Access Key',
      attributeName: 'accessKey',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Access Key for the S3 bucket',
      visibleWhen: {"field":"originType","value":"S3"}
    },  
    
    {
      label: 'Access Key',
      attributeName: 'accessKey',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Access key for the GCS bucket (S3 interoperability)',
      visibleWhen: {"field":"originType","value":"GCS"}
    },  
    {
      attributeName: 'username',      
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'UserName',
      helpText: 'Private Key Username',
      required: false,
      fileType: [''],
      visibleWhen: {"field":"originType","value":"SFTP"}
    },
    {
      attributeName: 'absoluteRoute',      
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Absolute Route',
      helpText: 'Absolute route of the files in the origin',
      required: false,
      visibleWhen: {"field":"originType","value":"SFTP"}
    },
    
    
    
  ],
};
